import { useEffect, useRef, useState } from "react";
import { trackEvent } from "../../utils/analytics";

export default function ArtistCard({ artist, index }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          trackEvent("wallet_artist_card_viewed", { artist_index: index, artist_slot: index + 1, artist_role: artist.role });
          obs.disconnect();
        }
      },
      { rootMargin: "-50px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`artist-card wlt-fadein ${visible ? "wlt-fadein--in" : ""}`}
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="artist-card__glow" style={{ background: artist.color }} />

      <div className="artist-card__body">
        <div className="artist-card__photo-wrap">
          <img src={artist.image} alt={artist.name} className="artist-card__photo" />
        </div>

        <div className="artist-card__info">
          <div className="artist-card__name-row">
            <h3 className="artist-card__name">{artist.name}</h3>
            <span className="artist-card__role">{artist.role}</span>
          </div>
          <p className="artist-card__desc">{artist.description}</p>
        </div>

        <div className="artist-card__pct-wrap">
          <span className="artist-card__pct-num">{artist.percentage}</span>
          <span className="artist-card__pct-sym">%</span>
        </div>
      </div>

      <div className="artist-card__bar-track">
        <div
          className="artist-card__bar-fill"
          style={{
            width: visible ? `${artist.percentage}%` : "0%",
            transitionDelay: `${0.3 + index * 0.1}s`,
          }}
        />
      </div>
    </div>
  );
}
